import dayjs from 'dayjs';
import { IUser } from 'domains/Admin/modules';
import { stringToDisplayDate } from 'utils';

export const useUserColumn = () => {
  const columns = [
    {
      id: 'no',
      label: 'No',
      render: (_: any, __: any, index: number) => {
        return index + 1;
      }
    },
    {
      id: 'username',
      label: 'Name'
    },
    {
      id: 'mobile',
      label: 'ID(Mobile)',
      render: (_: any, row: IUser) => {
        return `${row.mobile}`;
      }
    },
    {
      id: 'nationName',
      label: 'Nationality'
    },
    {
      id: 'iqamaNo',
      label: 'Iqama'
    },
    {
      id: 'iqamaExpiryDate',
      label: 'Iqama Expiry Date',
      render: (_: any, row: IUser) => {
        return stringToDisplayDate(row.iqamaExpiryDate);
      }
    },
    {
      id: 'authority',
      label: 'Authority'
    }
  ];

  return {
    columns
  };
};
